module.exports = __webpack_public_path__ + "img/2.632d269c.png";